export const validateYouTubeId = (id: string): { id: string; error: string | null } => {
  // Check for empty or invalid input
  if (!id || typeof id !== 'string') {
    return { id: '', error: 'YouTube ID not provided' };
  }

  // Check if the input is a valid YouTube ID
  // YouTube IDs are 11 characters consisting of alphanumeric characters, underscores, and hyphens
  if (/^[a-zA-Z0-9_-]{11}$/.test(id)) {
    return { id, error: null };
  }

  // If we get here, the ID format is not valid
  return {
    id: '',
    error:
      'Invalid YouTube ID format. Must be 11 characters and contain only letters, numbers, underscores, and hyphens.',
  };
};
